import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from "../hooks/useRefreshToken";
import useAuth from "../hooks/useAuth";

const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const refresh = useRefreshToken();
  const { currentUser, persist } = useAuth();

  useEffect(() => {
    let isMounted = true;

    const verifyRefreshToken = async () => {
      try {
        await refresh();
      } catch (err) {
        console.error("Error refreshing token:", err);
      } finally {
        isMounted && setIsLoading(false);
      }
    };

    if (!currentUser?.accessToken && persist) {
      verifyRefreshToken();
    } else {
      setIsLoading(false);
    }

    return () => {
      isMounted = false;
    };
  }, [currentUser?.accessToken, refresh, persist]);

  useEffect(() => {
    // console.log(`isLoading: ${isLoading}`);
    // console.log(`currentUserToken: ${JSON.stringify(currentUser?.accessToken)}`);
  }, [isLoading, currentUser?.accessToken]);

  return <>{!persist ? <Outlet /> : isLoading ? <p>Loading...</p> : <Outlet />}</>;
};

export default PersistLogin;
